export default "__VITE_ASSET__CKMJs1en__"